// extracted by mini-css-extract-plugin
export default {"dateLabel":"create-ticket-recurring_dateLabel__7Xtws","datePicker":"create-ticket-recurring_datePicker__Q+dxV","closeIcon":"create-ticket-recurring_closeIcon__-PsuI"};